const themesumut = {
    primary: '#034EA2',
    secondary: '#F58220',
    btnprimary: '#F58220',
};
export default themesumut